import { render, staticRenderFns } from "./RecibosCobranza.vue?vue&type=template&id=7bf147e0&"
import script from "./RecibosCobranza.vue?vue&type=script&lang=js&"
export * from "./RecibosCobranza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports